import React from "react";

/**
 * MpxButton (Phase B-1 Task 2)
 *
 * Props:
 *  - variant: 'primary' | 'secondary' | 'ghost' | 'danger' (default 'primary')
 *  - size: 'sm' | 'md' | 'lg' (default 'md')
 *  - disabled: boolean
 *  - loading: boolean (spinner + disabled)
 *  - icon: ReactNode
 *  - iconPosition: 'left' | 'right' (default 'left')
 *  - fullWidth: boolean
 *  - className: string (추가 클래스)
 *  - children: 버튼 텍스트
 *  - onClick, ...rest: button 요소에 전달
 */
export default function MpxButton({
  variant = "primary",
  size = "md",
  disabled = false,
  loading = false,
  icon = null,
  iconPosition = "left",
  fullWidth = false,
  className = "",
  children,
  ...rest
}) {
  const classes = [
    "mpx-btn",
    `mpx-btn--${variant}`,
    `mpx-btn--${size}`,
    fullWidth && "mpx-btn--full",
    (disabled || loading) && "mpx-btn--disabled",
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button className={classes} disabled={disabled || loading} {...rest}>
      {loading && <span className="mpx-btn__spinner" aria-hidden="true" />}
      {!loading && icon && iconPosition === "left" && (
        <span className="mpx-btn__icon" aria-hidden="true">
          {icon}
        </span>
      )}
      {children && <span className="mpx-btn__text">{children}</span>}
      {!loading && icon && iconPosition === "right" && (
        <span className="mpx-btn__icon" aria-hidden="true">
          {icon}
        </span>
      )}
    </button>
  );
}
